import { z } from "zod";

import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";

import { DEFAULT as DEFAULT_SETTINGS, type Settings } from "../../../components/widget-form/stat-chart/settings";
import { object, partial } from "../../_decoders";
import { Encoder } from "../../_encoder";
import { decoder as thresholdsStepsDecoder, encoder as thresholdsStepsEncoder } from "../thresholds/steps-spec";

const decoder = object({
	0: z.string().optional().catch(undefined),
	1: z.number().optional().catch(undefined),
	2: z.boolean().optional().catch(undefined),
	3: z.enum(ALL_CALCULATIONS).optional().catch(undefined),
	4: z.string().optional().catch(undefined),
	5: z.number().optional().catch(undefined),
	6: z.string().optional().catch(undefined),
	7: thresholdsStepsDecoder,
})
	.transform((fields) =>
		partial<Settings>({
			unit: fields[0],
			decimals: fields[1],
			sparkline: fields[2],
			calculation: fields[3],
			metricLabel: fields[4],
			fontSize: fields[5],
			color: fields[6],
			thresholds: fields[7],
		}),
	)
	.catch(undefined);

function encoder({
	unit,
	decimals,
	sparkline,
	calculation,
	metricLabel,
	fontSize,
	color,
	thresholds,
}: Settings): Encoder {
	return Encoder.shape({
		0: Encoder.primitive(unit, DEFAULT_SETTINGS.unit),
		1: Encoder.primitive(decimals, DEFAULT_SETTINGS.decimals),
		2: Encoder.primitive(sparkline, DEFAULT_SETTINGS.sparkline),
		3: Encoder.primitive(calculation, DEFAULT_SETTINGS.calculation),
		4: Encoder.primitive(metricLabel, DEFAULT_SETTINGS.metricLabel),
		5: Encoder.primitive(fontSize, DEFAULT_SETTINGS.fontSize),
		6: Encoder.primitive(color, DEFAULT_SETTINGS.color),
		7: thresholdsStepsEncoder(thresholds, DEFAULT_SETTINGS.thresholds),
	});
}

export { decoder, encoder };
